<template>
  <div
    class="pb-40 bg-slate-300"
    :style="{ minHeight: 'calc(100vh - 4.5rem - 0.5rem + 100vh)' }"
  >
    <div v-if="branch.id" class="analytics-sticky bg-slate-300">
      <div class="py-4 px-6 flex items-center justify-center">
        <BlTextTitle3 :text="branch.name" />
      </div>
      <div class="px-6 flex items-center justify-center">
        <div
          class="h-8 px-6 flex items-center gap-4 flex-shrink-0 border-b border-slate-400"
        >
          <router-link v-for="tab in tabs" :key="tab.value" :to="tab.target">
            <div
              class="h-full w-50 flex justify-center border-b-4"
              :class="[
                tab.isActive ? 'border-light-purple' : 'border-transparent'
              ]"
            >
              <BlTextSubtitle2 v-if="tab.isActive" :text="tab.label" />
              <BlTextBody1 v-else :text="tab.label" />
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="branch.id">
      <div
        v-if="!searchParams['tab'] || searchParams['tab'] === 'clients'"
        class="py-5 flex flex-col items-center gap-5"
      >
        <CurrentTotal />
        <ClientTurnover width="51.25rem" />
        <TeamPerformance />
        <AppointmentOverview />
        <CancellationOverview />
        <ClientsWithHighestCancellation width="51.25rem" />
        <ClientHours />
      </div>
      <div
        v-if="searchParams['tab'] === 'prospects'"
        class="py-5 flex flex-col items-center gap-5"
      >
        <ProspectsByStage />
        <TotalFinalOutcomesMadeDuringTimeframe />
        <ProspectsCountByStage />
        <div class="flex gap-5">
          <ReferralSource />
          <DiscontinuedReason />
        </div>
        <Conversion />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import CurrentTotal from "./mainDashboard/CurrentTotal.vue";
import ClientTurnover from "./mainDashboard/ClientTurnover.vue";
import TeamPerformance from "./mainDashboard/TeamPerformance.vue";
import AppointmentOverview from "./mainDashboard/AppointmentOverview.vue";
import CancellationOverview from "./mainDashboard/CancellationOverview.vue";
import ClientsWithHighestCancellation from "./mainDashboard/ClientsWithHighestCancellation.vue";
import ClientHours from "./mainDashboard/ClientHours.vue";

import ProspectsByStage from "./mainDashboard/ProspectsByStage.vue";
import TotalFinalOutcomesMadeDuringTimeframe from "./mainDashboard/TotalFinalOutcomesMadeDuringTimeframe.vue";
import ProspectsCountByStage from "./mainDashboard/ProspectsCountByStage.vue";
import ReferralSource from "./mainDashboard/ReferralSource.vue";
import DiscontinuedReason from "./mainDashboard/DiscontinuedReason.vue";
import Conversion from "./mainDashboard/Conversion.vue";

import BlTextTitle3 from "../BlTextTitle3.vue";
import BlTextSubtitle2 from "../BlTextSubtitle2.vue";
import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody1 from "../BlTextBody1.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlIcon from "../BlIcon.vue";

export default {
  name: "BranchOverview",
  components: {
    CurrentTotal,
    ClientTurnover,
    TeamPerformance,
    AppointmentOverview,
    CancellationOverview,
    ClientsWithHighestCancellation,
    ClientHours,
    ProspectsByStage,
    TotalFinalOutcomesMadeDuringTimeframe,
    ProspectsCountByStage,
    ReferralSource,
    DiscontinuedReason,
    Conversion,
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextSubtitle2,
    BlTextBody1,
    BlTextBody2,
    BlIcon
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "branches"]),
    enableSalesPipeline() {
      return this.currentCenter.enable_sales_pipeline;
    },
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    searchParams() {
      return this.$route.query || {};
    },
    paramsTab() {
      return this.$route.params.tab;
    },
    branch() {
      const branchId = Number(this.searchParams["branch"]);
      if (!branchId) return null;
      return (
        this.branches.find(i => i.id === branchId) || {
          name: "Branch not found"
        }
      );
    },
    tabs() {
      const branchId = this.searchParams["branch"];
      return [
        {
          target: `/analytics?branch=${branchId}&tab=clients`,
          label: "Clients",
          isActive:
            !this.searchParams["tab"] || this.searchParams["tab"] === "clients"
        },
        {
          target: `/analytics?branch=${branchId}&tab=prospects`,
          label: "Prospects",
          isActive: this.searchParams["tab"] === "prospects"
        }
      ];
    }
  },
  mounted() {
    if (!this.enableBranch) {
      return this.$router.push({ name: "Analytics" });
    }
  },
  methods: {
    ...mapActions([""])
  }
};
</script>

<style scoped lang="scss">
.analytics-sticky {
  width: calc(100vw - 15rem - 0.5rem);
  position: sticky;
  top: 4.5rem;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/analytics/BranchOverview.vue